import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import ProgramCategoryService from 'services/ProgramCategoryService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    data: []
}


export const addSubCategory = createAsyncThunk('programSubCategory/addSubCategory', async (data, { rejectWithValue }) => {
	
	try {
		const response = await ProgramCategoryService.addSubCategory(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const getSubCategory = createAsyncThunk('programSubCategory/getSubCategory', async (data, { rejectWithValue }) => {
	
	try {
		const response = await ProgramCategoryService.getSubCategory(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const programSubCategorySlice = createSlice({
    name: 'programSubCategory',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(addSubCategory.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(addSubCategory.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = 'Sub Category Added'
        })
        .addCase(addSubCategory.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getSubCategory.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getSubCategory.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload
            state.message = ''
        })
        .addCase(getSubCategory.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
    }
});



export default programSubCategorySlice.reducer;